<template>
  <div id="newScmgoods">
    <div class="btnBoxs" ref="element">
      <!-- <div>
        <span style="font-size: 0.75rem;">公司名称:</span>
      <el-select v-model="pattern" filterable placeholder="请选择" @change="firmVal"
        style="width: 215px;" size='mini' id='enterName'>
        <el-option key="index" label="全部" value="" v-if="companyids == '0'"></el-option>
        <el-option v-for="(item,index) in patternAll" :key="index" :label="item.name" :value="item.GZL_COMPANY_id_PK">
        </el-option>
      </el-select>
      </div> -->
      <div style="margin-right: 50px;">
      <span style="font-size: 0.75rem;">产品名称:</span>
      <el-select v-model="productName" filterable placeholder="请选择"
               style="width: 130px;" size='mini'>
      <el-option v-for="(item,index) in ProductName" :key="index" :label="item" :value="item">
      </el-option>
    </el-select>
    </div>
      <div class="middle">
        <span style="font-size: 0.75rem;">关键字:</span>
      <el-input v-model="keywords" autocomplete="off" style="width: 130px;" size='mini'>
      </el-input>
      </div>
      <div>
        <span style="font-size: 0.75rem;">可用库存:</span>
      <el-select v-model="canstock" filterable placeholder="请选择" @change="firmcanstock"
        style="width: 130px;margin-right: 30px;" size='mini'>
        <el-option v-for="(item,index) in canstockAll" :key="index" :label="item.name" :value="item.value">
        </el-option>
      </el-select>
      </div>
      <div>
          <el-button type="primary" size='mini'  icon="el-icon-search"  @click="search()">搜 索</el-button>
        <el-button  size='mini'  icon="el-icon-circle-close"  @click=" keywords = '',productName = '' " v-if="PCshow">清 空</el-button>
        </div>
    </div>
    <div class="btn">
        <!-- <el-button @click="search()">搜索</el-button>
        <el-button @click=" keywords = '' " v-if="PCshow">清空</el-button> -->
        <div>
        <el-button type="danger" size='mini'  icon="el-icon-delete" @click="delClick()" v-if="PCshow">批量删除</el-button>
        <el-button type="danger" size='mini' @click="Pcdelete()" v-if="!PCshow">批量删除</el-button>
        <el-button type="danger" size='mini' @click="offShelf()" v-if="PCshow">批量下架</el-button>
        <el-button type="primary" size='mini' @click="pricingClick()">批量编辑</el-button>
        <el-button @click="sort()" type="warning" size="mini" v-if="companyid =='0'">产品排序</el-button>
        <!-- <el-button @click="download()" type="warning" size="mini" v-if="companyids != 0">导出</el-button>
        <el-button @click="productdialog = true" type="success" size="mini" v-if="companyids != 0">导入</el-button> -->
        </div>
      </div>
    <el-table :data="showData" border @selection-change="handleSelectionChange" :height="TableHeight" v-loading="loading"  element-loading-text="拼命加载中">
      <el-table-column type="selection" width="55" align="center">
      </el-table-column>
      <el-table-column prop="LOG_SPOT_SALE_PRODUCT_id_PK" label="ID" width="55" align="center">
      </el-table-column>
      <el-table-column prop="rank_num" label="排序" width="55" align="center">
      </el-table-column>
      <el-table-column prop="name" label="产品名" align="center" show-overflow-tooltip width="170">
      </el-table-column>
      <el-table-column prop="image" label="图片" align="center">
        <template v-slot="scope">
          <img :src="scope.row.image" alt="" width="70" height="70">
        </template>
      </el-table-column>
      <el-table-column prop="spec" label="规格" align="center">
      </el-table-column>
      <el-table-column prop="mold" label="品种" align="center">
      </el-table-column>
      <el-table-column prop="platform_price" label="平台价格" align="center">
      </el-table-column>
      <el-table-column prop="vip_price" label="会员价格" align="center">
      </el-table-column>
      <el-table-column prop="factory" label="产地" align="center" show-overflow-tooltip width="120">
      </el-table-column>
      <el-table-column prop="warehouse" label="仓库" align="center" show-overflow-tooltip width="120" >
      </el-table-column>
      <el-table-column prop="stock" label="库存" align="center">
      </el-table-column>
      <el-table-column prop="allocated" label="已分配库存" align="center" width='100'>
      </el-table-column>
      <el-table-column prop="canstock" label="可用库存" align="center">
      </el-table-column>
      <!-- <el-table-column prop="sale_mode" label="销售状态" align="center" v-if="PCshow" show-overflow-tooltip width="100">
      </el-table-column> -->
      <el-table-column prop="status" label="审核状态" align="center" v-if="PCshow">
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="170" align="center" v-if="PCshow">
        <template slot-scope="scope">
          <el-button @click="edit(scope.row)" type="text" size="small" >编辑
          </el-button>
          <el-button @click="handleClick(scope.row)" type="text" size="small" >浏 览
          </el-button>
          <!-- <el-button @click="productClick(scope.row)" type="text" v-if="companyid !='0'" size="small">友 商 平 台 销 售
          </el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <el-dialog v-dialogDrag title="产品信息管理" :visible.sync="dlogTableVisible" width='70%'>
      <el-table :data="gridData" border style="width: 100%" size='small' @row-click="handleCurrentChange">
        <el-table-column prop="LOG_SPOT_SALE_PRODUCT_id_PK" label="id" width="50" align="center">
        </el-table-column>
        <el-table-column prop="name" label="产品名" align="center">
        </el-table-column>
        <el-table-column prop="image" label="产品图片" align="center">
          <template slot-scope="scope">
            <img :src="scope.row.image" alt="" width="70" height="70">
          </template>
        </el-table-column>
        <el-table-column prop="spec" label="规格" align="center">
        </el-table-column>
        <el-table-column prop="platform_price" label="平台价格" align="center">
      </el-table-column>
      <el-table-column prop="vip_price" label="会员价格" align="center">
      </el-table-column>
        <el-table-column prop="mold" label="品种" align="center">
        </el-table-column>
        <el-table-column prop="factory" label="产地" align="center">
        </el-table-column>
        <el-table-column prop="stock" label="库存" align="center">
        </el-table-column>
        <el-table-column prop="allocated" label="已分配库存" align="center" width='100'>
        </el-table-column>
        <el-table-column prop="canstock" label="可用库存" align="center">
        </el-table-column>
        <!-- <el-table-column prop="min_num" label="起售数量" align="center">
        </el-table-column> -->
      </el-table>
      <div style="margin-top: 1.25rem;">
        <el-form :model="setform" size='mini' :inline="true" label-position="left">
          <el-form-item label="ID:" :label-width="formLabelWidth" v-show='false' style="background: gray !important;">
            <el-input v-model="setform.LOG_SPOT_SALE_PRODUCT_id_PK" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="产品名:" :label-width="formLabelWidth">
            <el-input v-model="setform.name" autocomplete="off" :readonly="readonly"></el-input>
          </el-form-item>
          <el-form-item label="规格:" :label-width="formLabelWidth">
            <el-input v-model="setform.spec" autocomplete="off" :readonly="readonly"></el-input>
          </el-form-item>
          <el-form-item label="品种:" :label-width="formLabelWidth">
            <el-input v-model="setform.mold" autocomplete="off" :readonly="readonly"></el-input>
          </el-form-item>
          <el-form-item label="产地:" :label-width="formLabelWidth">
            <el-input v-model="setform.factory" autocomplete="off" :readonly="readonly"></el-input>
          </el-form-item>
          <el-form-item label="库存:" :label-width="formLabelWidth">
            <el-input v-model="setform.stock" autocomplete="off" :readonly="isReadonly"></el-input>
          </el-form-item>
          <el-form-item label="已分配库存:" :label-width="formLabelWidth">
            <el-input v-model="setform.allocated" autocomplete="off" :readonly="readonly"></el-input>
          </el-form-item>
          <el-form-item label="可用库存:" :label-width="formLabelWidth">
            <el-input v-model="setform.canstock" autocomplete="off" :readonly="readonly"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <el-button type="primary" @click="upPreserve()">保 存</el-button>
      <el-button type="danger" @click="imgregualte()">图片管理</el-button>
    </el-dialog>
    <!--图片管理  -->
    <el-dialog v-dialogDrag title="图片管理" :visible.sync="dialogImgregualte" width='70%'>
      <div class="mapDepot" v-if="dialogLmglibrary">
        <h1>商品图库</h1>
        <br />
        <div class="boxUpload">
          <div v-for="(item,index) in srcList" :key="index" class="demo-image__preview">
              <el-image
                style="width: 100px; height: 100px;"
                :src="item.link"
                :preview-src-list="raylist"
              >
              </el-image>
              <div class="checksty">
                <el-checkbox-group v-model="checkedCities" @change="clicheck(item)">
                  <el-checkbox :label="item.link"><br /></el-checkbox>
                </el-checkbox-group>
              </div>
           </div>
        </div>
        <div>
          <el-pagination
          background
          @current-change="currentChangeHandle2"
          :current-page="currentPage2"
          :page-size="pageSize2"
          layout="total, prev, pager, next, slot, jumper"
          :total="currentPage5"
          >
          <span slot style="width: 40px;color: dimgrey">
            <label><input name="Fruit" type="checkbox" value="" v-model="checkedc" @change="all2" />显示全部</label>
          </span>
        </el-pagination>
        <br />
          <el-button size="small" type="primary" @click="callOff()">取消</el-button>
          <el-button size="small" type="primary" @click="confirmin">确定</el-button>
        </div>
      </div>
      <br />
      <!-- 商品主题 -->
      <div>
        <div style="display: flex;align-items: center;">
          <h1>商品主图</h1> <span style="margin-left: 5px;">(图片最佳尺寸：800*800，支持格式png、jpg格式)</span>
        </div>
        <br />
        <el-upload
          :action="uploadfile"
          :before-upload="beforeAvatarUpload"
          :on-preview="handlePictureCardPreview"
          list-type="picture-card"
          :on-remove="handleRemove"
          :file-list="fileList"
           multiple
          :limit="5"
          :on-change="(file, fileList) => {handleChange(file, fileList);}"
          :on-exceed="(file, fileList) => {handleExceed(file, fileList);}"
          >
          <i class="el-icon-plus"></i>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible">
          <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
        <br />
        <el-button size="small" type="primary" @click="openDeliveryImg">从图片库选择</el-button>
      </div>
      <br />
    </el-dialog>
    <!-- 产品排序 -->
    <el-dialog v-dialogDrag title="产品排序" :visible.sync="dialog" width='30%'>
      <el-input type="number" v-model="valueUP" min="1" max="1000"></el-input>
      <el-alert title="从上往下进行排序 ,1最上!" type="success" :closable="false">
      </el-alert>
      <el-button type="primary" @click="sortUp()">保 存</el-button>
    </el-dialog>
    <!-- 上传友商产品 -->
    <el-dialog v-dialogDrag title="上传友商产品" :visible.sync="productdialog"  :before-close="handleClose">
      <el-upload
        ref="adModel"
        class="upload-demo"
        drag
        :action="uploadfile"
        :before-upload="beforeAvatarUploads"
        :on-exceed="handleExceeds"
        :on-remove="handleRemoves"
        :limit="1"
        :file-list = "fileLists"
        >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      </el-upload>
      <div class="saveBtn">
        <el-button type="primary" @click="save()">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 分页 -->
    <div class="block">
      <el-pagination class="pagination" @current-change="currentChangeHandle" background :current-page="currentPage1"
        :page-size="pageSize" layout=" prev, pager, next, slot, jumper" :total="currentPage4">
        <span slot style="width: 40px;color: dimgrey">
          <label><input name="Fruit" type="checkbox" value="" v-model="checked" @change="all" />显示全部</label>
        </span>
      </el-pagination>
    </div>
     <!-- 图片库 -->
     <photoGallery ref="child" @deliveryImg = deliveryImg></photoGallery>
  </div>
</template>
<script>
  import {
    changeproductrank,
    productputaway,
    companyoption,
    backphoto,
    backbrary,
    uploadfile,
    scmfile,
    backdelete,
    productname,
    productputaways,
    exportbusinessproducts,
    spotsaleinvoice,
    importbusinessproducts,
    companyproducts
  } from '../../static/API/API.js'
  import * as imageConversion from 'image-conversion'
  import photoGallery from '../components/photoGallery.vue'
  export default {
    components: { //动态组件
      photoGallery
    },
    data() {
      return {
        // 选中图片的值
        checkedCities:[],
        //图片库分页
        pageSize2: 1,
        currentPage5:0,
        currentPage2:1,
        scmCompanyid2: '',
        userName2:'',
        currentPage0:10,
        // 图片库分页复选框
        checkedc: false,
        //向后端传递的图片接口
        uploadfile: uploadfile,
        // 向后端传图片要用的token
        // 复选框
        checkede: false,
        // 图片库
        srcList: [],
        raylist:[],
        //商品主图
        fileList:[],
        fileLists:[],
        dialogImageUrl: '',
        dialogVisible: false,
        disabled: false,
        // 公司名称
        pattern:'',
        // 公司名称下拉数组
        patternAll:[],
        // 可用库存
        canstock:'0',
        // 公司名称下拉数组
        canstockAll:[
          {name:"全部",value:""},
          {name:"有库存产品",value:"0"},
          {name:"没有有库存产品",value:"-1"}
        ],
        //筛选
        keywords: '',
        showData: [],
        gridData: [],
        multipleSelection: [],
        formLabelWidth: '90px',
        // 分页
        currentPage4: 0,
        currentPage1: 1,
        currentPage: 7,
        pageSize: 1,
        //定价
        dlogTableVisible: false,
        //图片管理
        dialogImgregualte: false,
        // 图片库
        dialogLmglibrary:false,
        setform: {
          id: '',
          name: '',
          image: '',
          spec: '',
          price: '',
          purchprice: '',
          mold: '',
          factory: '',
          stock: '',
          sale_mode: '自营',
        },
        options: [{
          value: '选项1',
          label: '自营'
        }, {
          value: '选项2',
          label: '线下销售'
        }, {
          value: '选项3',
          label: '热销'
        }, ],
        readonly: true,
        isReadonly:true,
        department: '',
        companyid: '',
        // 是否显示全部
        checked: false,
        //pc端小程序显示
        PCshow: true,
        scmCompanyid: '',
        userName: '',
        //产品排序管理
        dialog:false,
        valueUP:'',
        //选中的图片链接传给后端
        checkedUrl:[],
        loading:false,
        TableHeight:490,
        ProductName:[], //牌号
        productName:'',
        spotsaleinvoice: spotsaleinvoice,
        productdialog:false,
        templateFile:'',
        companyids:''
      }
    },
  mounted() { //mounted是vue中的一个钩子函数，一般在初始化页面完成后，再对dom节点进行相关操作
      this.companyid = sessionStorage.getItem('companyid')
      this.companyids = sessionStorage.getItem('companyid')
      this.department = sessionStorage.getItem('department')
      this.handgetcompanylist()
      this.pagefeed()
      if (sessionStorage.getItem('companyid') != 0) {
        this.options = [{
          value: '选项1',
          label: '友商平台销售'
        },]
      }
    this.getHeight()
    this.getProductNameList()
    },
    created () {
    window.addEventListener('resize', this.getHeight)
  },
    destroyed () {
    window.removeEventListener('resize', this.getHeight)
  },
    methods: { //函数
      getHeight(){
    //动态计算表格高度
    this.$nextTick(()=>{
      let windowHeight = document.documentElement.clientHeight || document.bodyclientHeight;
      if(this.$refs.element.offsetHeight > 50){
        this.TableHeight = windowHeight - 274;//数值"140"根据需要调整
      }else{
        this.TableHeight = windowHeight - 275;//数值"140"根据需要调整
      }
    })
      },
       // before-upload上传文件之前的钩子 -- 限制文件大小
      beforeAvatarUpload(file) {
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
        const isLt2M = file.size / 1024 / 1024 < 5

        if (!isJpgOrPng) {
          this.$message.error('上传图片只能是JPG或PNG格式!');
          return false
        }
        if (!isLt2M) {
          this.$message.error('上传图片大小不能超过 5MB!');
          return false
        }
        return new Promise((resolve) => {
         // 以质量为0.6进行压缩，可自定义，可自定义
        imageConversion.compress(file, 0.8).then((res) => {
          let fd = new FormData();
        fd.append('file', file); //传文件
        this.$axios.post(uploadfile, fd).then(res=> {
        let dataRes = []
        dataRes = JSON.stringify(res.data)
        let setid = this.setform.LOG_SPOT_SALE_PRODUCT_id_PK
        let params = new URLSearchParams();
        params.append('productId',setid);//订单id
        params.append('imageUrl',dataRes);//图片url
        params.append('userId',sessionStorage.getItem('user_id'));
        this.$axios.post(backphoto,params).then(res =>{
            this.imgregualte()
        })
        params.append('ope_type', '添加')
        params.append('link', res.data)
        params.append('companyid', sessionStorage.getItem('companyid'))
        params.append('up_user', sessionStorage.getItem('user_id'))
        this.$axios.post(scmfile, params).then(res=> {
          this.$message({
            type: 'success',
            message: res.data,
            duration: 1000,
            showClose: true,
          });
        })
        })
            resolve(res)
        })
    })
      },
      beforeAvatarUploads(file){
        console.log(file,'file');
        this.templateFile = file
      },
      // 确定保存
      save(){
        if(this.templateFile  == ''){
          this.$message({
            title: "",
            message: "请上传文件！",
            type: "error",
            duration: 1000,
            showClose: true,
          });
          return
        }
        let fd = new FormData();
        fd.append('companyid',this.scmCompanyid);//友商公司id
        fd.append('file_name',this.templateFile);//文件名称
        this.$axios.post(importbusinessproducts,fd).then(res =>{
          if(res.data = 'ok'){
            this.$message({
            title: "",
            message: '上传成功',
            type: "success",
            duration: 1000,
            showClose: true,
          });
          }else{
            this.$message({
            title: "",
            message: res.data,
            type: "error",
            duration: 1000,
            showClose: true,
          });
          }
          this.handleClose()
          this.pagefeed(1, this.scmCompanyid, this.userName)
        })
      },
      // 关闭
      handleClose(done) {
        this.productdialog = false
        this.$refs.adModel.clearFiles()
        this.templateFile = ''
      },
      handleChange(file, fileList) {
        //获取上传文件大小
        let imgSize = Number(file.size / 1024 / 1024);
        if (imgSize > 20) {
          this.$message({
            title: "",
            message: "文件大小不能超过20MB，请重新上传。",
            type: "warning",
            duration: 1000,
            showClose: true,
          });
          return;
        }
      },
      handleExceeds(){
        this.$message({
            title: "",
            message: "最多上传一个文件！",
            type: "error",
            duration: 1000,
            showClose: true,
      });
      },
      handleExceed(){
        alert('亲，最大支持5张图片哦~')
      },
      // 商品管理
      // 删除
      handleRemove(file) {
        let params = new URLSearchParams();
        params.append('productId',file.productId);
        params.append('imageUrl', file.imageUrl);
        this.$axios.get(backdelete,{
          params
        }).then((res)=>{
          this.$message({
            type: 'success',
            message: res.data,
            duration: 1000,
            showClose: true,
          });
        })
      },
      handleRemoves(){
        this.templateFile = ''
      },
      // 放大
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      // 下载
      handleDownload(file) {
      },
      // 图片库显示全部图片
      all2(){
        if (this.checkedc) {
          this.currentPage0 = 'all'
          this.imglibrary(1, this.scmCompanyid2, this.userName2)
        } else {
          this.currentPage0 = 10
          this.imglibrary(1, this.scmCompanyid2, this.userName2)
        }
      },
      // 图片管理
      imgregualte(){
        let formModels = this.setform
        if(formModels.id == ''){
          alert('请选中订单~')
        }else{
          this.dialogImgregualte = true
          let params = new URLSearchParams();
          params.append('productId',formModels.LOG_SPOT_SALE_PRODUCT_id_PK);
          this.$axios.get(backphoto,{
            params
          }).then(res =>{
            res.data.forEach(item=>{
              item.url = item.imageUrl
            })
            this.fileList = res.data
          })
        }
      },
      // 取消图片库显示
      callOff(){
        this.dialogLmglibrary = false
      },
      // 图片库渲染
      imglibrary(e, companyid2, name2){
        this.dialogLmglibrary = true
        let params = new URLSearchParams();
        if (e) {
          params.append('page_number', e)
        } else {
          params.append('page_number', this.currentPage2)
        }
        params.append('page_size',this.currentPage0);
        params.append('file_type', 'photo');
        params.append('companyid', sessionStorage.getItem('companyid'));
        this.$axios.get(backbrary,{
          params
        }).then(res =>{
          let arr = []
          let listlist = []
          this.currentPage5 = Number(res.data[0]['PageNums'])
          res.data[0].pagedata.forEach(item =>{
              arr.push(item)
              listlist.push(item.link)
          })
          this.srcList = arr
          this.raylist = listlist
        })
      },
      // 选中图片加入商品中
      clicheck(val){
        this.checkedUrl = JSON.stringify(this.checkedCities)
      },
        // 打开图片库
        openDeliveryImg(){
        this.$refs.child.imglibrary();
      },
      deliveryImg(val){
        let setid = this.setform.LOG_SPOT_SALE_PRODUCT_id_PK
        let params = new URLSearchParams();
        params.append('productId',setid);//订单id
        params.append('imageUrl',val);//图片url
        params.append('userId',sessionStorage.getItem('user_id'));
        this.$axios.post(backphoto,params).then(res =>{
            this.imgregualte()
        })
      },
      // 确定
      confirmin(){
        let setid = this.setform.LOG_SPOT_SALE_PRODUCT_id_PK
        let params = new URLSearchParams();
        params.append('productId',setid);//订单id
        params.append('imageUrl',this.checkedUrl);//图片url
        params.append('userId',sessionStorage.getItem('user_id'));
        this.$axios.post(backphoto,params).then(res =>{
            this.imgregualte()
        })
        // 确定后取消选中状态
        this.checkedUrl = []
        this.checkedCities = []
      },
      firmVal(val) {
        this.companyid = val
        this.pagefeed(1, val, this.userName)
      },
      firmcanstock(val) {
        this.canstock = val
        this.pagefeed()
      },
      //图片库分页
      currentChangeHandle2(val){
        // 点击分页后取消选中状态
        this.checkedUrl = []
        this.checkedCities = []
        this.currentPage2 = val
        this.imglibrary(this.currentPage2, this.scmCompanyid2, this.userName2)
      },
      // 改变当前所在页
      currentChangeHandle(val) {
        this.currentPage1 = val
        this.pagefeed(this.currentPage1, this.scmCompanyid, this.userName)
      },
      // 监听pageSize文本框的变化，当pageSize为空时，设置pageSize的值为0，以防报错
      all() {
        if (this.checked) {
          this.currentPage = 'all'
          this.pagefeed(1, this.scmCompanyid, this.userName)
        } else {
          this.currentPage = 7
          this.pagefeed(1, this.scmCompanyid, this.userName)
        }
      },
      handleCurrentChange(val) {
        if(val.companyid != '0'){
          this.isReadonly = false
        }else{
          this.isReadonly = true
        }
        this.setform = val
      },
      pricingClick() {
        this.gridData = this.multipleSelection
        if (this.gridData.length > 0) {
          this.dlogTableVisible = true
          this.gridData.forEach(e => {
            delete e.status
          })
        } else {
          alert('未选中要管理的产品')
        }
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      pagefeed(e, companyid, name) {
        this.loading = true
        let params = new URLSearchParams();
        if (e) {
          params.append('page_number', e)
        } else {
          params.append('page_number', this.currentPage1)
        }
        params.append('page_size', this.currentPage)
        params.append('keyword', this.keywords);
        params.append('name', this.productName);
        params.append('canstock', this.canstock);

        params.append('ope_type', 'all');
        this.$axios.get(companyproducts, {
          params
        }).then((res) => {
          console.log(res);
          this.currentPage4 = Number(res.data['page_total'])
          res.data['result'].forEach(item=>{
            if(item.image&&item.image.indexOf(',')>-1){
              item.image = item.image.split(',')[0]
            }
         })
          this.showData = res.data['result']
          setTimeout(() => {
            this.loading = false
          }, 300);
        })
      },
      //下架
      offShelf() {
        if(this.multipleSelection.length == 0){
          this.$message({
                  type: 'error',
                  message: '请勾选产品！',
                  duration: 1000,
                });
                return
        }
        this.multipleSelection.map(e => {
          // e.sale_mode = '自营'
          e.status='待审核'
          // if (e.status) {
          //   delete e.status
          // }
        })
        let params = new URLSearchParams();
        params.append('ope_type', 'update');
        params.append('user_id', sessionStorage.getItem('user_id'))
        params.append('datas', JSON.stringify(this.multipleSelection))
        this.$axios.post(productputaway, params).then(res => {
          if(res.data == 'ok'){
            this.$alert('下架成功！', {
            confirmButtonText: '确定',
            callback: action => {
            }
          });
          }else{
            this.$alert(res.data, {
            confirmButtonText: '确定',
            callback: action => {
            }
          });
          }
          this.pagefeed(this.currentPage1, this.scmCompanyid, this.userName)
        });
      },
      //平台销售
      productClick(row) {
        row.sale_mode = '友商平台销售'
        delete row.status
        this.$confirm('此操作将该商品放入友商平台销售, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let params = new URLSearchParams();
          params.append('ope_type', 'update');
          params.append('user_id', sessionStorage.getItem('user_id'))
          params.append('datas', JSON.stringify([row]))
            this.$alert(res.data, {
              confirmButtonText: '确定',
              callback: action => {
                this.$message({
                  type: 'info',
                  message: res.data,
                  duration: 1000,
            showClose: true,
                });
                this.pagefeed(1, this.scmCompanyid, this.userName)
              }
            });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
            duration: 1000,
            showClose: true,
          });
        });
      },
      //维 护
      handleClick(row) {
        let url = ''
        if (window.location.hostname == 'data.ziyichain.cn') {
        url = 'https://shop.ziyichain.cn/'
        }else {
        url = 'https://s.ziyichain.cn/'
        }
        window.open(url + 'product/' + row.LOG_SPOT_SALE_PRODUCT_id_PK)

      },
      edit(row){
        if(row.companyid != '0'){
          this.isReadonly = false
        }else{
          this.isReadonly = true
        }
        delete row.status
        this.gridData = [row]
        this.setform = row
        this.dlogTableVisible = true
      },
      //产品排序
      sort(){
        this.dialog=true
      },
      // 友商产品表格下载
      download(){
        let params = new URLSearchParams();
          params.append('companyid', this.scmCompanyid)
          this.$axios.post(exportbusinessproducts, params).then(res => {
            window.open(res.data)
            setTimeout(()=>{
              this.$message({
              type: 'success',
              message: `下载成功！`,
              duration: 1000,
            showClose: true,
            });
            },500)
          })
      },
      sortUp(){
        let P_id=''
        this.multipleSelection.forEach(e =>{
          P_id+=e.LOG_SPOT_SALE_PRODUCT_id_PK+','
        })
        let params =new URLSearchParams()
        params.append("p_id",P_id)
        params.append("rank_num",this.valueUP)
        this.$axios.post(changeproductrank,params).then(res =>{
          this.$alert('产品已排序！', {
            confirmButtonText: '确定',
            callback: action => {
              this.$message({
                type: 'info',
                message: res.data,
                duration: 1000,
            showClose: true,
              });
              this.dialog = false
              this.pagefeed(1, this.scmCompanyid, this.userName)
            }
          });
        })
      },
      upPreserve() {
        this.gridData.forEach(e =>{
          e.status ='待审核'
        })
        let params = new URLSearchParams();
        params.append('datas', JSON.stringify(this.gridData))
        this.$axios.post(productputaways, params).then(res => {
            this.$alert('产品做出修改，请等待审核通过！', {
              confirmButtonText: '确定',
              callback: action => {
                this.$message({
                  type: 'info',
                  message: `产品做出修改，请等待审核通过！`,
                  duration: 1000,
            showClose: true,
                });
                this.dlogTableVisible = false
                this.pagefeed(this.currentPage1, this.scmCompanyid, this.userName)
              }
            });
        });
      },
      // 搜索
      search(){
        this.currentPage1 = 1
        this.pagefeed(1,this.scmCompanyid,this.userName)
      },
      //删除产品
      async delClick() {
        let multipleSelection = this.multipleSelection
        let changeData = []
        for (let i = 0; i <= multipleSelection.length - 1; i++) {
          changeData = multipleSelection
          if(multipleSelection[i].companyid == '0' && multipleSelection[i].status == '待审核'){
            await this.$alert('该商品不可删除！', {
              confirmButtonText: '确定',
              callback: action => {
                this.$message({
                  type: 'info',
                  message: `该商品不可删除！`,
                  duration: 1000,
            showClose: true,
                });
              }
            });
          }else if (multipleSelection[i].status != '待审核') {
            await this.$alert('请先下架再删除产品！', {
              confirmButtonText: '确定',
              callback: action => {
                this.$message({
                  type: 'info',
                  message: `请先下架再删除产品！`,
                  duration: 1000,
            showClose: true,
                });
              }
            });
          }
        }
        if (multipleSelection.some(e => Object.is(e.status, '待审核' || companyid, '1'))) {
          for (let i = 0; i <= changeData.length - 1; i++) {
            changeData[i].is_delete = '1'
          }
          let params = new URLSearchParams();
          params.append('datas', JSON.stringify(changeData))
          await this.$axios.post(productputaways, params).then(res => {
            this.$message({
              type: 'info',
              message: `产品已删除！`,
              duration: 1000,
            showClose: true,
            });
            // const totalPage = Math.ceil((this.currentPage4 - 1) / this.currentPage) // 总页数
            // this.currentPage1 = this.currentPage > totalPage ? totalPage : this.currentPage
            // this.currentPage1 = this.currentPage < 1 ? 1 : this.currentPage

            let totalPage = Math.ceil((this.currentPage4 - 1) / this.currentPage)
            let currentPage = this.currentPage1 > totalPage ? totalPage : this.currentPage1
            this.currentPage1 = currentPage < 1 ? 1 : currentPage
            this.pagefeed(this.currentPage1, this.scmCompanyid, this.userName)
          })
        }
      },
      async Pcdelete() {
        let multipleSelection = this.multipleSelection
        let changeData = []
        for (let i = 0; i <= multipleSelection.length - 1; i++) {
          multipleSelection[i].is_delete = 1
          changeData = multipleSelection
        }
        let params = new URLSearchParams();
        params.append('ope_type', 'update');
        params.append('user_id', this.userName)
        params.append('datas', JSON.stringify(changeData))
        await this.$axios.post(productputaway, params).then(res => {
          this.$message({
            type: 'info',
            message: `产品已删除！`,
            duration: 1000,
            showClose: true,
          });
          this.pagefeed(1, this.scmCompanyid, this.userName)
        })
      },
      handgetcompanylist(){
        let params = new URLSearchParams();
        this.$axios.get(companyoption, {
          params
        }).then((res) => {
          this.patternAll = res.data
          this.pattern = Number(sessionStorage.getItem('companyid'))

        })
      },
      getProductNameList(){
        let params = new URLSearchParams();
        this.$axios.post(productname, {}).then((res) => {
          this.ProductName = res.data.message
        })
      }
    },
    computed: { //计算属性

    }
  }
</script>
<style scoped>
  .demo-image__preview{
    position: relative;
    margin-right: 5px;
  }
 .checksty{
    position: absolute;
    top: 0;
    right: 0;
  }
 [class*=" el-icon-"], [class^=el-icon-] {
  margin-right: 0px;
}
.boxUpload{
  width: 55%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  /* justify-content: space-between; */
}
.btnBoxs{
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  line-height: 40px;
}
.middle{
  /* margin: 0 60px; */
  margin-right: 50px;
}
.btn{
  display: flex;
  justify-content: space-between;
  margin: 10px 0;
  margin-bottom: 15px;
}
/deep/ .el-upload-dragger{
  width: 45vw !important;
}
.saveBtn{
  display: flex;
  justify-content: center;
  margin-top: 30px;
}
/deep/ .el-upload-list__item {
  transition: none !important;
}
</style>



// WEBPACK FOOTER //
// src/views/newScmgoods.vue